import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MainButton from "./MainButton";
import { sendContact } from "../../slices/11-ContactUs/thunk";
import InputField from "./InputField";
import TextareaField from "./TextareaField";
import { PhoneIcon } from "lucide-react";

const UnderLineForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.contact);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    additional_notes: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(sendContact({ type: "default", ...formData }))
      .unwrap()
      .then(() => {
        setFormData({
          full_name: "",
          email: "",
          phone: "",
          additional_notes: "",
        });
      })
      .catch(() => { });
  };

  useEffect(() => {
    if (success) {
      toast.success(t("underlineform.successMessage"));
    }

    if (error) {
      toast.error(error || t("underlineform.errorMessage"));
    }
  }, [success, error, t]);

  return (
    <div className="w-full max-w-2xl mx-auto">
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 gap-5 md:grid-cols-2"
      >
        <div className="md:col-span-2">
          <label className="block mb-2 font-medium text-gray-700 dark:text-gray-100">
            {t("underlineform.FullName")}
          </label>
          <InputField
            type="text"
            name="full_name"
            placeholder={t("underlineform.FullName")}
            value={formData.full_name}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-2 font-medium text-gray-700 dark:text-gray-100">
            {t("underlineform.Email")}
          </label>
          <InputField
            type="email"
            name="email"
            placeholder={t("underlineform.Email")}
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-2 font-medium text-gray-700 dark:text-gray-100">
            {t("underlineform.PhoneNumber")}
          </label>
          <InputField
            type="text"
            name="phone"
            placeholder={t("underlineform.PhoneNumber")}
            value={formData.phone}
            onChange={handleChange}
            icon={PhoneIcon}
          />
        </div>

        <div className="md:col-span-2">
          <label className="block mb-2 font-medium text-gray-700 dark:text-gray-100">
            {t("underlineform.Message")}
          </label>
          <TextareaField
            name="additional_notes"
            rows={4}
            placeholder={t("underlineform.Message")}
            value={formData.additional_notes}
            onChange={handleChange}
          />
        </div>

        <div className="flex justify-end md:col-span-2">
          <MainButton type="submit" disabled={loading}>
            {loading
              ? t("underlineform.Sending")
              : t("underlineform.Send")}
          </MainButton>
        </div>
      </form>
    </div>
  );
};

export default UnderLineForm;